import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Layout from 'components/Layout';
import hasAuthToken from 'lib/hasAuthToken';
import Link from 'next/link';

const JobSeekersPage = () => {
  const { t } = useTranslation();

  return (
    <Layout title={t('jobSeekers.pageTitle')}>
      <div className="o-retain o-retain--lap u-margin-top-huge u-margin-bottom-huge">
        <h1>{t('jobSeekers.pageHeading')}</h1>
        <p>
          <strong>
            deBanenSite.nl is hét online vacature platform van Nederland! Op
            onze vacaturesite vind je alleen vacatures die direct afkomstig zijn
            van werkgevers. Wat zijn de voordelen van deBanenSite?
          </strong>
        </p>
        <ul>
          <li>
            deBanenSite is ruim 20 jaar de vacaturesite met vacatures van alleen
            directe werkgevers;
          </li>
          <li>
            Je reageert volledig anoniem: je sollicitatie komt rechtstreeks bij
            de werkgever terecht;
          </li>
          <li>Dagelijks een nieuw aanbod met actuele vacatures;</li>
          <li>De vacatures staan branche-gerelateerd gesorteerd;</li>
          <li>
            Je vindt de vacatures snel en eenvoudig door middel van onze
            zoekfunctie;
          </li>
          <li>
            Jouw cv wordt direct opgeslagen in onze database en is daardoor ook
            voor werkgevers vindbaar;
          </li>
          <li>
            Je kunt vacatures zoeken in jouw omgeving dankzij Google Maps;
          </li>
          <li>
            Geen vacature gevonden? Maak een e-mail alert aan en ontvang
            automatisch vacatures die voldoen aan jouw profiel;
          </li>
        </ul>
        <p>
          <strong>
            Ervaar het zelf,{' '}
            <Link href="/vacatures">
              start nu jouw zoektocht naar jouw droombaan
            </Link>
            !
          </strong>
        </p>
        <p>
          Meer weten over deBanenSite? Volg ons dan ook op onze social
          mediakanalen{' '}
          <a
            href="https://www.facebook.com/debanensite.nl"
            rel="external noreferrer"
            target="_blank"
          >
            Facebook
          </a>
          ,{' '}
          <a
            href="https://www.twitter.com/debanensite"
            rel="external noreferrer"
            target="_blank"
          >
            Twitter
          </a>
          , <a href="https://www.instagram.com/debanensite">Instagram</a> en
          <a
            href="https://www.linkedin.com/company/debanensite-nl"
            rel="external noreferrer"
            target="_blank"
          >
            LinkedIn
          </a>
          , waar je de laatste nieuwtjes vindt en je op de hoogte blijft van de
          laatste informatie, vacatures en carrièreadvies.
        </p>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res, locale }) {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default JobSeekersPage;
